module.exports = __webpack_public_path__ + "img/2.d14223a3.jpg";